export const styles = theme => ({
  root: {
    textTransform: "none",
    fontWeight: "bold",
  },
});

export default styles;
